import React from "react";
import styled from "styled-components";
import IUMRSspeakers from "./IUMRSSpeakers";
import IUMRSFooter from "./IUMRSFooter"
import image1 from "../../../assets/partners-img/African mrs.png"
import image2 from "../../../assets/partners-img/University-of-Ghana logo.jpg"
import image3 from "../../../assets/partners-img/iumrs logo.jpg"
import image4 from "../../../assets/partners-img/UGNAA.png"
import image5 from "../../../assets/images/cedi_conference.jpg"
import ImportantDates from "./ImportantDates";
import SymposiumTheme from "./SymposiumTheme";
import { useDesktopSiteDetection } from "../../../hooks/mobile_desktop_mode";
import NotificationDropdown from "../../../hooks/notificationsDropdown";


const dates = [
    { title: "Abstract submission", period: "March - June 2025", icon: "📝" },
    { title: "Author registration", period: "Apr - July 2025", icon: "👨‍🔬" },
    { title: "Early Bird registration", period: "April - Sept 2025", icon: "🐦" },
    { title: "Exhibitor/Sponsorship deadline", period: "Nov 2025", icon: "🤝" },
    { title: "Tour Ghana", period: "13th Dec 2025", icon: "🧳" }
  ];

const IUMRSHome = () => {

    const isDesktopSiteOnMobile = useDesktopSiteDetection()
    
    return (
        <Container className={isDesktopSiteOnMobile ? 'desktop-site-mode' : ''}>
            <NotificationDropdown />
            <IntroBox className={isDesktopSiteOnMobile ? 'desktop-site-mode' : ''}>
            <div className="main-field">
                <div className="image-header">
                    <img 
                        className="iumrs2025" 
                        src={image5}
                        alt="IUMRS Event"
                    />
                </div>
                <div className="detail-box">
                    
                        <ImportantDates />
                
                </div>
            </div>
            </IntroBox>

            <div className="title">
                <h2>19th IUMRS-ICAM, ACCRA-GHANA 2025</h2>
            </div>

            <div className="summary-section">
                <div className="intro-text">
                    <span>University of Ghana in collaboration with the International Union of Materials Research Societies 
                        (IUMRS) and the African Materials Research Society (AMRS) presents the 19th International Conference 
                        on Advanced Materials (ICAM)</span>  
                </div>

                <div className="main-text">
                    <p>Encouraged by the success of the International Conference on Advanced Materials (IUMRS-ICAM) series held since 1988 and the impact it has created among the materials science and engineering research community both in the region and elsewhere, the African Materials Research 
                        Society (African MRS) will for the first time in Africa be organizing the 19th edition of the conference series from 9th – 12th December 2025 in Accra, Ghana. Pre-conference workshops will be held on the 7th and 8th December at the same venue. 
                        This year’s workshops will feature a diverse lineup, including an Electrospinning and Nanofiber Synthesis workshop, Metrohm Electrochemistry sessions, and a Winter School on Sustainable and Renewable Energy, among others.
                    </p> 
                    <p>The upcoming conference, with an expected participation of 600 - 800 delegates, comprises, technical symposia, plenary and theme lectures, special activities, exhibition as well as keynote, invited, oral and poster presentations. IUMRS-ICAM 2025 is the premier scientific 
                        platform to present research to an interdisciplinary and international audience. It provides a window on the future of materials science and offers an opportunity for researchers – from students and postdocs, to Nobel Laureates – to share expertise, exchange technical information and network with colleagues.</p>
                    <p>The conference will focus on broad
                        Advanced Materials research themes, including some of special interest to Africa. The Conference also
                        will provide an opportunity for policy, education and networking dialogue, and help define challenges and future
                        priorities for materials research and development.
                        </p>
                    <p>The main conference will be held at the ISSER Conference Hall, University of
                        Ghana, Legon, Accra Ghana and begin promptly at 9:00 am Tuesday, December 9th for the Opening Ceremony. There
                        will be buses from the respective places of lodging to and from the Conference Venue.</p>
                </div>

                <SymposiumTheme/>
                <IUMRSspeakers />
            </div>
            <Organizers>
                    <HeaderContainer>
                        <HeaderDivider>
                        <div className="line"></div>
                        <div className="diamond">
                            <svg viewBox="0 0 24 24" width="50" height="50">
                                <path fill="currentColor" d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 2.02 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
                                <path fill="currentColor" d="M16.5 19c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2z" opacity="0.7"/>
                            </svg>
                        </div>
                        <div className="line"></div>
                        </HeaderDivider>
                        <Title>Partnering Organizations</Title>
                    </HeaderContainer>
                    <div className="partners-section">
                        <div>
                            <img src={image2} height="100px"/>
                        </div>
                        <div>
                            <img src={image1} height="100px"/>
                        </div>
                        <div>
                            <img src={image3} height="100px"/>
                        </div>
                        <div>
                            <img src={image4} height="100px"/>
                        </div>
                    </div>
                </Organizers>

            <IUMRSFooter/>
            
        </Container>
    )
}

const Container = styled.div`


    .title {
        width: 100%;
        display: flex;
        justify-content: center;
        margin: 20px 0 0 0;

        h2 {
            text-align: center;
            color: #CA9D3B;
            max-width: 90%;
            font-size: 2em;
        }
    }

    .summary-section{

        font-family: "Noto Serif", serif;
        font-weight: 300;
        margin: 0em 2em 1em 2em;

        p{
            color: rgb(97, 96, 96);
            line-height: 1.8em;
            font-size: 1.1em;
        }

        .main-text{ text-align: justify;}
    }
    .intro-text {
        width: 100%;
        display: flex;
        justify-content: center;
        text-align: center;

        span{
            color:  #082D4A;
            font-weight: 600;
            font-size: 1.2rem;
            margin-bottom: 1rem;
        }
    
        p {
            max-width: 90%;}
    }

    .sponsor-section{
        background-color: #082D4A;
    }

    @media only screen and (min-width: 800px) {
        .summary-section{
            margin: 0em 3em 1em 3em;
        }
    }

    @media only screen and (min-width: 1000px) {
        .title{
            h2{
                font-size: 2.9em;
            }
        }
        .summary-section{
            width: 56em;
            margin: 0 auto;
        }
    }

    &.desktop-site-mode{

        .title{ h2{ font-size: 2.5em; } }

        .summary-section{
        margin: 0em 3em 1em 3em;

        p{
            font-size: 0.7em;
        }
    }
    .intro-text {

        span{
            font-size: 0.9rem;
            margin-bottom: 2rem;
        }
    }
`;

const IntroBox = styled.div`

    .main-field {
        background-color: #082D4A;
        width: 100%;
        height: 95vh;
        display: flex;
        flex-direction: column;
        animation: heroLoad 2s ease-in-out;
        position: relative;

        @media only screen and (min-width: 450px){
                height: 130vh;
        }

        @media only screen and (min-width: 850px){
                height: 150vh;
        }

        .image-header {
            width: 100%;
            height: 35%;

            
            .iumrs2025 {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }            
        }

        .detail-box {
            width: 100%;
            height: 65%;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0px 0;
            overflow: auto;
        }
        @media only screen and (min-width: 450px){
            .image-header {height: 50%;}
            .detail-box {height: 50%;}
            }

        @media only screen and (min-width: 1000px) {
            flex-direction: row;
            height: 77.5vh;

            .image-header {
                width: 60%;
                height: 100%;
                
                .iumrs2025 {
                    object-fit: cover;
                }
            }

            .detail-box {
                width: 40%;
                height: 100%;
                align-items: center;
                justify-content: center;
            }
        }
    }

    @keyframes heroLoad{
        from{
            clip-path: polygon(0 0, 100% 0, 100% 0, 0 0);
        }
        to{
            clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
        }
    }

    &.desktop-site-mode{
        .main-field {
            height: 30vh;
            flex-direction: row;

            .image-header {
                width: 60%;
                height: 100%;
                
                .iumrs2025 {
                    object-fit: cover;
                }
            }

            .detail-box {
                width: 40%;
                height: 100%;
                align-items: center;
                justify-content: center;
            }
        }
    }

`

const HeaderContainer = styled.div`
  text-align: center;
  margin-bottom: 1rem;
`;

const HeaderDivider = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;

  .line {
    height: 1px;
    background-color: #d1d5db;
    width: 3rem;
  }

  .diamond {
    margin: 0 1rem;
    color: #3b82f6;
  }
`;

const Title = styled.h2`
  font-size: 1.875rem;
  font-weight: bold;
  text-transform: uppercase;
  color: #1f2937;
`;

const Organizers = styled.div`
    
    background-color: white;
    #margin: 10rem 0 5rem 0;
    width: 80%;
    height: 20rem;
    font-size: 2rem;
    font-weight: 400;
    margin: 25rem auto;
    margin-top: 5rem;
    color:   #082D4A;

    span{
        text-align: justify;
        font-size: 1.875rem;
        font-weight: bold;
        text-transform: uppercase;
        margin-bottom: 2rem;
        }

    .partners-section{
        
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        gap: 1.5rem;
        justify-items: center;
    }

    @media (min-width: 640px) {
        margin: 10rem auto;
        .partners-section{
        grid-template-columns: repeat(2, 1fr);
        }
    }

    @media (min-width: 920px) {
        margin: 5rem auto;
        .partners-section{
        grid-template-columns: repeat(4, 1fr);
        }
    }

`

export default IUMRSHome;